module.exports = __webpack_public_path__ + "assets/setting-icon.4f0c976a.svg";